import { create } from 'zustand';
import type { AppliedEffectDTO, EncounterCurrentNodeDTO, EncounterDTO, NpcPublicDTO, PendingLootDTO, SkillCheckResultDTO } from '@hexcrawl/shared-utils';

interface EncounterState {
  activeEncounter: EncounterDTO | null;
  currentNode: EncounterCurrentNodeDTO | null;
  npcName: string | null;
  npcPublicData: NpcPublicDTO | null;
  skillCheckResult: SkillCheckResultDTO | null;
  appliedEffects: AppliedEffectDTO[] | null;
  pendingLootOnClose: PendingLootDTO | null;
  // NPC to re-open a follow-on conversation with once any reward loot is dismissed
  // (set after a quest turn-in; see EncounterOverlay.handleComplete).
  pendingFollowUpNpcId: string | null;

  setActiveEncounter: (encounter: EncounterDTO, node: EncounterCurrentNodeDTO, npcName?: string, appliedEffects?: AppliedEffectDTO[], pendingLootOnClose?: PendingLootDTO) => void;
  setPendingLootOnClose: (loot: PendingLootDTO) => void;
  setPendingFollowUpNpcId: (npcId: string | null) => void;
  updateEncounter: (encounter: EncounterDTO) => void;
  updateCurrentNode: (node: EncounterCurrentNodeDTO) => void;
  setNpcPublicData: (npc: NpcPublicDTO) => void;
  clearActiveEncounter: () => void;
  setSkillCheckResult: (result: SkillCheckResultDTO) => void;
  clearSkillCheckResult: () => void;
  setAppliedEffects: (effects: AppliedEffectDTO[]) => void;
  clearAppliedEffects: () => void;
}

export const useEncounterStore = create<EncounterState>()((set) => ({
  activeEncounter: null,
  currentNode: null,
  npcName: null,
  npcPublicData: null,
  skillCheckResult: null,
  appliedEffects: null,
  pendingLootOnClose: null,
  pendingFollowUpNpcId: null,

  setActiveEncounter: (encounter, node, npcName, appliedEffects, pendingLootOnClose) => set({ activeEncounter: encounter, currentNode: node, npcName: npcName ?? null, npcPublicData: null, appliedEffects: appliedEffects ?? null, pendingLootOnClose: pendingLootOnClose ?? null }),
  setPendingLootOnClose: (loot) => set({ pendingLootOnClose: loot }),
  setPendingFollowUpNpcId: (npcId) => set({ pendingFollowUpNpcId: npcId }),
  updateEncounter: (encounter) => set({ activeEncounter: encounter }),
  updateCurrentNode: (node) => set({ currentNode: node }),
  setNpcPublicData: (npc) => set({ npcPublicData: npc }),
  clearActiveEncounter: () => set({ activeEncounter: null, currentNode: null, npcName: null, npcPublicData: null, skillCheckResult: null, appliedEffects: null, pendingLootOnClose: null }),
  setSkillCheckResult: (result) => set({ skillCheckResult: result }),
  clearSkillCheckResult: () => set({ skillCheckResult: null }),
  setAppliedEffects: (effects) => set({ appliedEffects: effects }),
  clearAppliedEffects: () => set({ appliedEffects: null }),
}));
